// test1243
(1243 && 0);
